import router from '@/router';
import axios from 'axios';
import store from '@/store';
import { TOKEN_TYPE, API_BASE_URL, BACKEND_URL } from '@/config';

const jwtdecode = require('jwt-decode');
const IS_PROD = process.env.NODE_ENV === 'production';

var axios_ = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export default {
  user: {
    authenticated: false,
  },

  // Send a request to the login URL and save the returned JWT
  login(context, creds, redirect) {
    return new Promise((resolve, reject) => {
      let LOGIN_URL = API_BASE_URL + 'auth/user_auth';
      let env = process.env.NODE_ENV === 'production' ? 'PROD' : 'LOCAL';
      context.$store.commit('set_env', env);
      axios
        .post(LOGIN_URL, creds)
        .then(async response => {
          if (response.data.token) {
            let app_url = response.data.app_url;
            let domain = response.data.domain;
            this.authMe(response, context, app_url, domain);
          } else {
            resolve({ status: false });
          }
        })
        .catch(err => reject(err));
    });
  },

  logout(context) {
    return new Promise((resolve, reject) => {
      let LOGOUT_URL = API_BASE_URL + 'auth/logout';
      axios_
        .post(LOGOUT_URL, { refresh: store.getters.user.refresh_token })
        .then(response => {
          if (response.data) {
            localStorage.removeItem('user');
            localStorage.removeItem('fleets');
            localStorage.removeItem('selected_fleet');
            localStorage.removeItem('favorite_reports');
            localStorage.removeItem('notification_options');
            localStorage.removeItem('notification_alarms');
            sessionStorage.removeItem('notifications');
            let loginUrl = 'login';
            router.go(loginUrl);
            axios_.defaults.headers.common['Authorization'] = '';
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  clearAuth() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_store');
    localStorage.removeItem('fleets');
    localStorage.removeItem('selected_fleet');
  },

  checkAuth() {
    var jwt = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['authenticated'] : false;
    if (jwt) {
      this.user.authenticated = true;
    } else {
      this.user.authenticated = false;
    }
  },

  getAuthHeader() {
    let token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['access_token'] : false;
    if (token) {
      return TOKEN_TYPE + ' ' + token;
    } else {
      return false;
    }
  },

  // In Auth service
  refreshToken(context) {
    return new Promise(function (resolve) {
      let refresh = store.getters.user.refresh_token;
      let REFRESH_TOKEN_URL = API_BASE_URL + 'auth/refresh_token';
      axios_
        .post(REFRESH_TOKEN_URL, { refresh: refresh })
        .then(response => {
          let payload = jwtdecode(response.data.access);
          payload['token'] = response.data.access;
          payload['refresh_token'] = refresh;
          payload['status'] = true;
          payload['profile'] = store.getters.user.profile;
          payload['map_settings'] = store.getters.user.tag_settings;
          payload['notification_options'] = store.getters.user.notification_options;
          payload['notification_alarms'] = store.getters.user.notification_alarms;
          payload['groups'] = store.getters.user.groups;
          payload['maps'] = store.getters.user.maps;
          payload['tile'] = store.getters.user.tile;

          axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + payload['token'];
          store.commit('set_user', payload);
          store.commit('refreshSocket');
          resolve(response.data.token);
        })
        .catch(error => {
          console.log(error);
          localStorage.removeItem('user');
          let loginUrl = '/login';
          router.go(loginUrl);
        });
    });
  },
  checkExpiredToken(token) {
    let payload = jwtdecode(token);
    let currentDate = new Date().getTime() / 1000;
    return payload.exp > currentDate;
  },
  authMe(response, context, app_url, domain) {
    app_url = API_BASE_URL;
    domain = BACKEND_URL;
    return new Promise((resolve, reject) => {
      let payload = jwtdecode(response.data.token);
      payload['refresh_token'] = response.data.refresh;
      payload['token'] = response.data.token;
      payload['status'] = true;
      let app_url_last_char = app_url.slice(-1);
      let domain_last_char = domain.slice(-1);
      if (app_url_last_char !== '/') {
        app_url += '/';
      }
      if (domain_last_char.slice(-1) !== '/') {
        domain += '/';
      }
      axios_.defaults.headers.common['Authorization'] = TOKEN_TYPE + ' ' + payload['token'];
      axios
        .post(
          app_url + 'auth/me',
          {},
          {
            headers: {
              Authorization: `JWT ${response.data.token}`,
            },
          }
        )
        .then(response => {
          payload['profile'] = response.data.profile;
          payload['maps'] = response.data.maps;
          payload['groups'] = response.data.groups;
          payload['map_settings'] = response.data.map_settings;
          payload['notification_options'] = response.data.notification_options;
          payload['notification_alarms'] = response.data.notification_alarms;
          payload['tile'] = response.data.selected_map_tile;

          context.$i18n.locale = response.data.selected_language;
          context.$store.commit('change_lang', response.data.selected_language);
          context.$store.commit('set_user', payload);
          context.$store.commit('refreshSocket');
          context.$store.commit('setPermission', response.data.permissions);
          context.$store.commit('set_fleets', response.data.fleets);
          context.$store.commit('set_url', { domain: domain, app_url: app_url });
          context.$store.commit('set_icon_type', response.data.icon_type);
          localStorage.setItem('favorite_reports', JSON.stringify(response.data.favorite_reports));
          // self.$store.commit('setAllGroups', response.groups)
          setTimeout(() => {
            const main_page = response.data.fleets?.[0]?.main_page || '/dashboard';
            context.$router.push(main_page);
          }, 100);
          resolve({ status: true });
        })
        .catch(err => reject(err));
    });
  },
};
